import React from 'react';
import { AWSCloudAccountAdd } from './AWSCloudAccountAdd';
import { AWSCloudAccountEdit } from './AWSCloudAccountEdit';

/**
 * AWS Cloud Account - Orchestrator Component
 * Routes to Add or Edit mode based on isEditMode prop
 */
export const AWSCloudAccount = ({ isEditMode, ...props }) => {
    return isEditMode ? <AWSCloudAccountEdit {...props} /> : <AWSCloudAccountAdd {...props} />;
};
